/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendAuthEmailRequest
 */
export interface SendAuthEmailRequest {
    /**
     * User email address
     * @type {string}
     * @memberof SendAuthEmailRequest
     */
    email: string;
    /**
     * Type of user portal
     * @type {string}
     * @memberof SendAuthEmailRequest
     */
    userType: SendAuthEmailRequestUserTypeEnum;
}


/**
 * @export
 */
export const SendAuthEmailRequestUserTypeEnum = {
    Patient: 'patient',
    Provider: 'provider',
    Admin: 'admin'
} as const;
export type SendAuthEmailRequestUserTypeEnum = typeof SendAuthEmailRequestUserTypeEnum[keyof typeof SendAuthEmailRequestUserTypeEnum];


/**
 * Check if a given object implements the SendAuthEmailRequest interface.
 */
export function instanceOfSendAuthEmailRequest(value: object): value is SendAuthEmailRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('userType' in value) || value['userType'] === undefined) return false;
    return true;
}

export function SendAuthEmailRequestFromJSON(json: any): SendAuthEmailRequest {
    return SendAuthEmailRequestFromJSONTyped(json, false);
}

export function SendAuthEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendAuthEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'userType': json['userType'],
    };
}

export function SendAuthEmailRequestToJSON(json: any): SendAuthEmailRequest {
    return SendAuthEmailRequestToJSONTyped(json, false);
}

export function SendAuthEmailRequestToJSONTyped(value?: SendAuthEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'userType': value['userType'],
    };
}

